import React from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function SelectModePage() {
  const navigate = useNavigate();
  const { roomCode } = useParams();

  return (
    <div style={{ padding: 40 }}>
      <h2>یک گزینه را انتخاب کنید</h2>
      <div style={{ display: "flex", gap: 20 }}>
        <button onClick={() => navigate(`/watch/${roomCode}`)}>تماشای فیلم</button>
        <button onClick={() => navigate(`/video-call/${roomCode}`)}>پخش موزیک</button>
        <button onClick={() => navigate(`/game/${roomCode}`)}>🎮 بازی</button> {/* ✅ این دکمه */}
      </div>
    </div>
  );
}
